import {checklistResources, helpResources, subThematicResources} from '@workspaces/bdese/_resources';
import {WorkspaceResource} from '@workspaces/resources';

export const resources: WorkspaceResource[] = [...subThematicResources, ...helpResources, ...checklistResources];
